import * as GA from 'modules/app/services/ga/constants';
import GtagService from 'modules/app/services/ga/GtagService';

const ANALYTICS_EVENTS = GtagService.createEvents({
  common: {
    name: GA.CATEGORIES.SALES_SECTION,
    category: GA.CATEGORIES.SALES_SECTION
  },
  [GA.LABELS.TOGGLE_ON]: {
    action: GA.ACTIONS.FREE_SIGN_UP,
    label: GA.LABELS.TOGGLE_ON
  },
  [GA.LABELS.TOGGLE_OFF]: {
    action: GA.ACTIONS.FREE_SIGN_UP,
    label: GA.LABELS.TOGGLE_OFF
  }
});

export default {
  freeSignUpToggle: (checked) => {
    const event = checked
      ? ANALYTICS_EVENTS[GA.LABELS.TOGGLE_ON]
      : ANALYTICS_EVENTS[GA.LABELS.TOGGLE_OFF];

    event && GtagService.send(event);
  }
};
